export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: number;
  updatedAt: string;
  featured: boolean;
}

export interface Chapter {
  id: string;
  comicId: string;
  title: string;
  number: number;
  updatedAt: string;
  views: number;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-apps-line' },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { name: '动作', slug: 'action', icon: 'ri-flashlight-line' },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line' },
  { name: '都市', slug: 'urban', icon: 'ri-building-line' },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line' },
  { name: 'BL', slug: 'bl', icon: 'ri-user-heart-line' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '重生之都市仙尊',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20webtoon%20cover%20art%20style%2C%20a%20handsome%20male%20protagonist%20with%20flowing%20dark%20hair%20and%20glowing%20eyes%20in%20a%20modern%20city%20night%20setting%2C%20surrounded%20by%20magical%20energy%20sparks%2C%20dramatic%20lighting%2C%20vibrant%20manga%20art%20style%2C%20clean%20composition%20on%20plain%20dark%20background&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '都市平凡少年意外重生，凭借前世记忆，一步步踏上修仙之路。在充满危机与机遇的现代都市中，他能否逆转命运，登上仙界之巅？',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['重生', '修仙', '都市', '战斗'],
    status: '连载中',
    rating: 4.8,
    views: 1285000,
    chapters: 156,
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 'comic-2',
    title: '霸道总裁的契约新娘',
    author: '李恩智',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%20art%2C%20beautiful%20female%20lead%20with%20long%20wavy%20hair%20in%20an%20elegant%20dress%2C%20handsome%20male%20lead%20in%20a%20suit%20standing%20behind%20her%2C%20romantic%20atmosphere%2C%20soft%20pastel%20color%20palette%2C%20rose%20petals%20falling%2C%20clean%20composition%20on%20simple%20light%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '为了拯救家族企业，她签下了一纸契约婚姻。本以为只是各取所需，却没想到冷面总裁的深情超乎想象。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['契约婚姻', '总裁', '甜宠', '都市'],
    status: '连载中',
    rating: 4.6,
    views: 956000,
    chapters: 89,
    updatedAt: '2026-08-03',
    featured: true,
  },
  {
    id: 'comic-3',
    title: '暗黑领主崛起',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20Korean%20webtoon%20cover%2C%20a%20powerful%20dark%20knight%20with%20glowing%20red%20eyes%20and%20black%20armor%2C%20holding%20a%20massive%20sword%2C%20dark%20castle%20in%20the%20background%2C%20ominous%20atmosphere%2C%20manga%20art%20style%2C%20dramatic%20lighting%2C%20clean%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '被背叛而死的传奇英雄，在地狱中沉沦千年后重获新生。这一次，他要让整个世界臣服于他的脚下！',
    category: '动作',
    categorySlug: 'action',
    tags: ['暗黑', '复仇', '战斗', '奇幻'],
    status: '已完结',
    rating: 4.9,
    views: 2150000,
    chapters: 200,
    updatedAt: '2026-07-28',
    featured: true,
  },
  {
    id: 'comic-4',
    title: '我的邻居是九尾狐',
    author: '崔秀英',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20webtoon%20romantic%20comedy%20cover%2C%20a%20girl%20with%20fox%20ears%20and%20tail%20in%20modern%20apartment%20setting%2C%20blushing%20expression%2C%20warm%20and%20playful%20tone%2C%20soft%20color%20palette%2C%20clean%20manga%20art%20style%2C%20simple%20light%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '搬进新家后，她发现隔壁住着一只修炼千年的九尾狐！人与妖的爆笑同居生活就此展开。',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['九尾狐', '同居', '搞笑', '恋爱'],
    status: '连载中',
    rating: 4.7,
    views: 1820000,
    chapters: 134,
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 'comic-5',
    title: '深渊之眼',
    author: '郑宇成',
    cover: 'https://readdy.ai/api/search-image?query=Thriller%20Korean%20webtoon%20cover%20art%2C%20a%20mysterious%20detective%20in%20a%20trench%20coat%20standing%20in%20rainy%20alleyway%2C%20red%20string%20connecting%20crime%20scene%20clues%2C%20dark%20and%20moody%20atmosphere%2C%20manga%20art%20style%2C%20cinematic%20lighting%2C%20clean%20composition&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '拥有特殊能力的刑警，能够看到死者最后看到的画面。一桩连环杀人案让他看到了不该看到的东西……',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['悬疑', '刑侦', '超能力', '惊悚'],
    status: '连载中',
    rating: 4.8,
    views: 1120000,
    chapters: 78,
    updatedAt: '2026-08-02',
    featured: false,
  },
  {
    id: 'comic-6',
    title: '便利店夜班生',
    author: '姜东元',
    cover: 'https://readdy.ai/api/search-image?query=Slice%20of%20life%20Korean%20webtoon%20cover%2C%20a%20young%20man%20in%20convenience%20store%20uniform%20at%20night%2C%20neon%20lights%20reflecting%2C%20warm%20cozy%20atmosphere%20inside%20the%20store%2C%20relaxed%20manga%20art%20style%2C%20soft%20colors%2C%20clean%20composition&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '大学退学后，他在便利店上夜班维生。每一个深夜顾客都有自己的故事，平凡生活中的温暖与感动。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['日常', '治愈', '都市', '温情'],
    status: '已完结',
    rating: 4.5,
    views: 678000,
    chapters: 60,
    updatedAt: '2026-07-15',
    featured: false,
  },
  {
    id: 'comic-7',
    title: '首席设计师',
    author: '韩素希',
    cover: 'https://readdy.ai/api/search-image?query=Fashion%20industry%20Korean%20webtoon%20cover%2C%20stylish%20female%20designer%20with%20sketchbook%20in%20elegant%20studio%2C%20fashion%20sketches%20and%20fabric%20swatches%20around%2C%20chic%20and%20modern%20aesthetic%2C%20clean%20manga%20art%20style%2C%20sophisticated%20color%20palette%2C%20simple%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '从小小助理到顶级品牌首席设计师，她用才华和努力在时尚界闯出一片天。职场奋斗与时尚梦想。',
    category: '都市',
    categorySlug: 'urban',
    tags: ['职场', '时尚', '励志', '都市'],
    status: '连载中',
    rating: 4.4,
    views: 534000,
    chapters: 95,
    updatedAt: '2026-08-01',
    featured: false,
  },
  {
    id: 'comic-8',
    title: '樱花树下的约定',
    author: '朴敏英',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20BL%20Korean%20webtoon%20cover%2C%20two%20handsome%20young%20men%20standing%20under%20blooming%20cherry%20blossom%20tree%2C%20gentle%20eye%20contact%2C%20soft%20pink%20and%20white%20color%20palette%2C%20delicate%20manga%20art%20style%2C%20spring%20atmosphere%2C%20clean%20composition&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '高中时在樱花树下许下的约定，十年后他们再次相遇。那些年的暗恋，能否开出最美的花？',
    category: 'BL',
    categorySlug: 'bl',
    tags: ['青春', '暗恋', '重逢', '温情'],
    status: '连载中',
    rating: 4.7,
    views: 890000,
    chapters: 72,
    updatedAt: '2026-08-04',
    featured: false,
  },
  {
    id: 'comic-9',
    title: '剑与魔法学院',
    author: '金宇彬',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20academy%20cover%20art%2C%20students%20in%20magical%20school%20uniforms%20holding%20swords%20and%20staffs%2C%20grand%20castle%20academy%20building%20in%20background%2C%20colorful%20magic%20spells%2C%20adventure%20manga%20art%20style%2C%20bright%20and%20vivid%20colors%2C%20clean%20composition&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '平凡少年意外被剑与魔法学院录取，在充满魔法与冒险的校园里，他发现自己隐藏的惊人天赋。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['学院', '魔法', '冒险', '成长'],
    status: '连载中',
    rating: 4.6,
    views: 1450000,
    chapters: 188,
    updatedAt: '2026-08-03',
    featured: true,
  },
  {
    id: 'comic-10',
    title: '恋爱操作团',
    author: '孙艺珍',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20Korean%20webtoon%20cover%2C%20a%20team%20of%20young%20people%20in%20matching%20outfits%20looking%20mischievous%2C%20love%20letter%20and%20heart%20shapes%20floating%2C%20bright%20and%20playful%20atmosphere%2C%20vibrant%20manga%20art%20style%2C%20colorful%20but%20clean%20composition&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '一个专门帮人追爱的神秘团队，却没想到操作团成员之间也产生了剪不断理还乱的感情纠葛。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '搞笑', '团队', '青春'],
    status: '已完结',
    rating: 4.3,
    views: 756000,
    chapters: 88,
    updatedAt: '2026-07-20',
    featured: false,
  },
  {
    id: 'comic-11',
    title: '影子杀手',
    author: '赵寅成',
    cover: 'https://readdy.ai/api/search-image?query=Action%20Korean%20webtoon%20cover%2C%20a%20masked%20assassin%20in%20black%20outfit%20leaping%20between%20buildings%20at%20night%2C%20dual%20pistols%20in%20hands%2C%20neon%20city%20lights%20below%2C%20dynamic%20action%20pose%2C%20manga%20art%20style%2C%20intense%20lighting%2C%20clean%20composition&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '曾经的王牌特工隐退后成为普通人，但过去的敌人不会放过他。为了保护家人，他必须再次拿起武器。',
    category: '动作',
    categorySlug: 'action',
    tags: ['特工', '战斗', '悬疑', '紧张'],
    status: '连载中',
    rating: 4.8,
    views: 1670000,
    chapters: 123,
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 'comic-12',
    title: '美食猎人',
    author: '刘在锡',
    cover: 'https://readdy.ai/api/search-image?query=Food%20adventure%20Korean%20webtoon%20cover%2C%20a%20cheerful%20chef%20with%20cooking%20utensils%20exploring%20exotic%20locations%2C%20delicious%20dishes%20and%20ingredients%20displayed%2C%20warm%20and%20appetizing%20color%20palette%2C%20manga%20art%20style%2C%20clean%20composition%20on%20simple%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '为了寻找传说中的食材，少年美食猎人踏上环球之旅。每一道美食背后，都藏着动人的故事。',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['美食', '冒险', '搞笑', '治愈'],
    status: '连载中',
    rating: 4.5,
    views: 623000,
    chapters: 67,
    updatedAt: '2026-08-02',
    featured: false,
  },
];

export const getAllCategories = () => categories;

export const getFeaturedComics = () => comics.filter(c => c.featured);

export const getLatestComics = (limit = 8) =>
  [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);

export const getPopularComics = (limit = 8) =>
  [...comics].sort((a, b) => b.views - a.views).slice(0, limit);

export const getComicsByCategory = (slug: string) =>
  slug === 'all' ? comics : comics.filter(c => c.categorySlug === slug);

export const getComicById = (id: string) => comics.find(c => c.id === id);

export const getRelatedComics = (id: string, limit = 4) => {
  const comic = getComicById(id);
  if (!comic) return [];
  return comics
    .filter(c => c.id !== id && c.categorySlug === comic.categorySlug)
    .slice(0, limit);
};

export const generateChapters = (comic: Comic): Chapter[] => {
  const chapters: Chapter[] = [];
  for (let i = comic.chapters; i >= 1; i--) {
    const date = new Date(comic.updatedAt);
    date.setDate(date.getDate() - (comic.chapters - i));
    chapters.push({
      id: `${comic.id}-ch-${i}`,
      comicId: comic.id,
      title: `第${i}话`,
      number: i,
      updatedAt: date.toISOString().split('T')[0],
      views: Math.floor(Math.random() * 50000) + 1000,
    });
  }
  return chapters;
};